import _get from 'lodash.get'

import { createReducer, updateState } from 'redux_new/handlers'
import { conversationAddressTypes, conversationsTypes } from 'redux_new/conversations/types'

const initialAddress = {
  isOpen: false,
  isLoading: false,
  address: null,
}

const initialState = {
  initial: { ...initialAddress },
  // [USER.id]: initialAddress
}

/**
 * Display or not address info
 * @param {Object} action
 * @param {string} action.userId
 * @param {boolean} action.isOpen
 * @param {boolean} [action.isLoading=false]
 */
const conversationAddressDisplay = (state, action) => {
  const { isOpen, userId, isLoading = false } = action

  return updateState(state, {
    [userId]: {
      ...(state[userId] || initialAddress),
      isOpen,
      isLoading,
    },
  })
}

/**
 * Update address
 * @param {Object} action
 * @param {string} action.userId
 * @param {Object} action.address
 */
const conversationAddressUpdate = (state, action) => {
  const { userId, address } = action

  const userAddress = address ? address : _get(state, `${userId}.address`, initialAddress.address)

  return updateState(state, {
    [userId]: {
      ...(state[userId] || initialAddress),
      isLoading: false,
      address: userAddress,
    },
  })
}

/**
 * Remove user from conversationAddress
 * @param {Object} action
 * @param {string} action.userId
 */
const conversationsRemoveOne = (state, action) => {
  const { userId } = action

  delete state[userId]

  return updateState(state)
}

export default createReducer(initialState, {
  [conversationAddressTypes.display]: conversationAddressDisplay,
  [conversationAddressTypes.update]: conversationAddressUpdate,
  [conversationsTypes.removeOne]: conversationsRemoveOne,
  [conversationsTypes.removeAll]: () => updateState(initialState),
})
